import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';

@Injectable()
export class FinalReportService {

  constructor(private _httpService: BackendService) { }

  public getUserCycleReport(
    userId: string, cycleId: number
  ): Observable<any> {
    return this._httpService.get('getUserCycleReport', [], [
      { 'name': 'userId', 'value': userId },
      { 'name': 'cycleId', 'value': cycleId as any },
    ]);
  }

}
